<template>
  <a-layout-header
    v-if="!headerBarFixed"
    :class="[fixedHeader && 'ant-header-fixedHeader', sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed', ]"
    :style="{ padding: '0' }"
  >
    <div v-if="mode === 'sidemenu'" class="header">
      <a-icon v-if="device==='mobile'" class="trigger" :type="collapsed ? 'menu-fold' : 'menu-unfold'" @click="toggle"/>
      <a-icon v-else class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="toggle"/>
      <user-menu></user-menu>
    </div>
    <div v-else :class="['top-nav-header-index', theme]">
      <div class="header-index-wide">
        <div class="header-index-left" :style="{width: returnWidth}">
          <logo class="top-nav-header" :show-title="!collapsed"/>
          <div class="currentPage">
            <span>当前页&ensp;-&ensp;</span>
            <span style="color: rgba(8, 64, 159, 1)">{{ secondaryMenu }}</span>
          </div>
          <s-menu v-if="device !== 'mobile'" mode="horizontal" :menu="menus" :theme="theme" />
          <a-icon v-else class="trigger" :type="collapsed ? 'menu-fold' : 'menu-unfold'" @click="toggle" />
        </div>
        <user-menu class="header-index-right"></user-menu>
      </div>
    </div>
  </a-layout-header>
</template>

<script>
import UserMenu from '../tools/UserMenu'
import SMenu from '../Menu/'
import Logo from '../tools/Logo'

import { mixin } from '@/utils/mixin'
import { handleScrollHeader } from '@/utils/util'
import { mapGetters } from 'vuex'

export default {
  name: 'GlobalHeader',
  components: {
    UserMenu,
    SMenu,
    Logo
  },
  computed: {
    ...mapGetters(['userInfo']),
    returnWidth () {
      let width = ''
      if (this.computeWidth(this.userInfo.deptFullName) > this.computeWidth(this.userInfo.name + this.userInfo.jobTitleName) + 1) {
        width = this.computeWidth(this.userInfo.deptFullName) + 'em'
      } else {
        width = this.computeWidth(this.userInfo.name + this.userInfo.jobTitleName) + 1 + 'em'
      }
      console.log(`calc(100% - ${width} - 42px - 24px)`)
      return `calc(100% - ${width} - 42px - 24px)`
    }
  },
  mixins: [mixin],
  props: {
    mode: {
      type: String,
      // sidemenu, topmenu
      default: 'sidemenu'
    },
    menus: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    device: {
      type: String,
      required: false,
      default: 'desktop'
    }
  },
  data () {
    return {
      headerBarFixed: false,
      secondaryMenu: ''
    }
  },
  created () {
    this.secondaryMenu = this.$route.meta.title
  },
  watch: {
    $route (to, from) {
      this.secondaryMenu = to.meta.title
    }
  },
  mounted () {
    const _this = this
    handleScrollHeader(direction => {
      _this.handleScroll(direction)
    })
  },
  methods: {
    computeWidth (field) {
      // 判断userInfo.name中有几个英文字符
      let nameLengthEn = 0
      let nameLengthCn = 0
      // 去空格
      if (!field) {
        return 0
      }
      field = field.trim()
      for (let i = 0; i < field.length; i++) {
        if (field.charCodeAt(i) <= 255) {
          nameLengthEn += 1
        } else {
          nameLengthCn += 1
        }
      }
      // nameLength除2向上取整
      nameLengthEn = Math.ceil(nameLengthEn / 2)
      return nameLengthEn + nameLengthCn
    },
    handleScroll (direction) {
      if (this.autoHideHeader) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (direction === 'up') {
          this.headerBarFixed = false
        } else {
          scrollTop > 100 && (this.headerBarFixed = true)
        }
      } else {
        this.headerBarFixed = false
      }
    },
    toggle () {
      this.$emit('toggle')
    }
  }
}
</script>
<style lang="less" scoped>
.currentPage {
  padding: 8px 12px;
  background-color: rgba(23, 145, 255, 0.15);
  border-radius: 3px;
  height: 28px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: auto;
  margin-bottom: auto;
  span {
    display: inline-block;
    line-height: 28px;
    font-weight: bold;
  }
}
</style>
<!--<style scoped lang="less">-->
<!--/deep/.header-index-wide {-->
<!--  padding-left: 8px !important;-->
<!--  margin: 0!important;-->
<!--}-->
<!--/deep/.top-nav-header {-->
<!--  width: 330px !important;-->
<!--  color: #08409F !important;-->
<!--  font-size: 18px !important;-->
<!--  font-weight: 500 !important;-->
<!--}-->
<!--/deep/.ant-menu-item-selected {-->
<!--  position: relative;-->
<!--  border-bottom: 2px solid rgba(0, 0, 0, 0.01) !important;-->
<!--  .ant-menu-item-selected {-->
<!--    a {-->
<!--      color: #08409F !important;-->
<!--    }-->
<!--  }-->
<!--}-->
<!--/deep/.ant-menu-horizontal {-->
<!--  .ant-menu-submenu-selected {-->
<!--    position: relative;-->
<!--    border-bottom: 2px solid rgba(0, 0, 0, 0.01) !important;-->
<!--  }-->
<!--}-->
<!--/deep/.ant-menu-horizontal {-->
<!--  .ant-menu-submenu:hover {-->
<!--    position: relative;-->
<!--    border-bottom: 2px solid rgba(0, 0, 0, 0.01) !important;-->
<!--    :after{-->
<!--      content: '';-->
<!--      width: 20px;-->
<!--      height: 3px;-->
<!--      background-color: #08409F;-->
<!--      position: absolute;-->
<!--      bottom: 0;-->
<!--      right: 0;-->
<!--      left: 0;-->
<!--      margin: auto;-->
<!--      -webkit-box-sizing: border-box;-->
<!--      box-sizing: border-box;-->
<!--    }-->
<!--  }-->
<!--}-->
<!--/deep/.ant-menu-horizontal {-->
<!--  .ant-menu-item:hover {-->
<!--    position: relative;-->
<!--    border-bottom: 2px solid rgba(0, 0, 0, 0.01) !important;-->
<!--    :after{-->
<!--      content: '';-->
<!--      width: 20px;-->
<!--      height: 3px;-->
<!--      background-color: #08409F;-->
<!--      position: absolute;-->
<!--      bottom: 0;-->
<!--      right: 0;-->
<!--      left: 0;-->
<!--      margin: auto;-->
<!--      -webkit-box-sizing: border-box;-->
<!--      box-sizing: border-box;-->
<!--    }-->
<!--  }-->
<!--}-->
<!--/deep/.ant-menu-item-selected :after {-->
<!--  content: '';-->
<!--  width: 20px;-->
<!--  height: 3px;-->
<!--  background-color: #08409F;-->
<!--  position: absolute;-->
<!--  bottom: 0;-->
<!--  right: 0;-->
<!--  left: 0;-->
<!--  margin: auto;-->
<!--  -webkit-box-sizing: border-box;-->
<!--  box-sizing: border-box;-->
<!--}-->
<!--/deep/.ant-menu-horizontal {-->
<!--  .ant-menu-submenu-selected :after{-->
<!--    content: '';-->
<!--    width: 20px;-->
<!--    height: 3px;-->
<!--    background-color: #08409F;-->
<!--    position: absolute;-->
<!--    bottom: 0;-->
<!--    right: 0;-->
<!--    left: 0;-->
<!--    margin: auto;-->
<!--    -webkit-box-sizing: border-box;-->
<!--    box-sizing: border-box;-->
<!--  }-->
<!--}-->

<!--</style>-->
